/**
 * <TutorDelayConfirmStep> — « Signaler un retard » : ce qu'on attend du masteur en retard
 * (organism).
 *
 * L'étape « Retard de N minutes. » de l'ancien `MoveSessionReasonComponent`, et son encadré
 * « Important » mot pour mot : ne pas recommencer, laisser du travail aux élèves, compenser en fin
 * de séance.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { AlertCard } from "../../molecules/AlertCard"

export type TutorDelayConfirmStepProps = {
    minutes: number
    testID?: string
}

export function TutorDelayConfirmStep(props: TutorDelayConfirmStepProps) {
    const { minutes, testID } = props
    return (
        <Stack gap="3" testID={testID}>
            <Text weight="bold" color="text-primary">{`Retard de ${minutes} minutes.`}</Text>
            <AlertCard
                severity="warning"
                title="Important"
                message={
                    <Stack gap="2">
                        <Text size="text-sm" color="text-primary">
                            C'est bien de prévenir quand un retard est inévitable, mais il ne faut pas que cela se
                            répète !
                        </Text>
                        <Text size="text-sm" weight="bold" color="text-primary">
                            Merci de vérifier que chaque élève a des activités pertinentes à faire en attendant ton
                            arrivée.
                        </Text>
                        <Text size="text-sm" weight="bold" color="text-primary">
                            Il faudra compenser ce retard en fin de séance !
                        </Text>
                    </Stack>
                }
            />
        </Stack>
    )
}
